var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_401_1188",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 21
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.542969,
    y: 0.5,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_401_1188)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.20898 20.5V17.1666H18.8757V20.5H2.20898ZM5.54232 13.8333H6.70898L13.209 7.35413L12.0215 6.16663L5.54232 12.6666V13.8333ZM3.87565 15.5V11.9583L13.209 2.64579C13.3618 2.49301 13.5388 2.37496 13.7402 2.29163C13.9416 2.20829 14.1534 2.16663 14.3757 2.16663C14.5979 2.16663 14.8132 2.20829 15.0215 2.29163C15.2298 2.37496 15.4173 2.49996 15.584 2.66663L16.7298 3.83329C16.8965 3.98607 17.018 4.16663 17.0944 4.37496C17.1708 4.58329 17.209 4.79857 17.209 5.02079C17.209 5.22913 17.1708 5.43399 17.0944 5.63538C17.018 5.83677 16.8965 6.02079 16.7298 6.18746L7.41732 15.5H3.87565Z",
    fill: "#51606F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit_icon.713126a196ea0575499c69c28af8f909.svg";
export { ForwardRef as ReactComponent };